import { cx } from "@linaria/core"
import { observer } from "mobx-react-lite"
import { useEffect, useRef } from "react"

import { DiffFileHeaderStyles } from "@/components/DiffFile/DiffFileHeaderStyles.ts"
import { Ellipsis, EllipsisContainer } from "@/components/Ellipsis/Ellipsis.ts"
import { ChevronDownRegular, CloseLight, Icon20 } from "@/icons/Icons.ts"
import { preventTextSelection } from "@/lib/std.ts"
import { HeadingStyles } from "@/styles/Markdown.ts"

import type { DiffFileModel } from "@/components/DiffFile/DiffFileModel.ts"


export const FileHeaderComponent = observer((props: {
  vm: DiffFileModel
}) => {
  const ref = useRef<HTMLDivElement | null>(null)

  const onClick = props.vm.isCollapsible ? () => {
    props.vm.toggleCollapse()
  } : undefined

  const filePath = props.vm.filePath
  const fileName = props.vm.fileName

  useEffect(() => {
    const scrollToHash = () => {
      if (window.location.hash.slice(1) === (filePath + fileName) && ref.current) {
        ref.current.scrollIntoView()
      }
    }

    scrollToHash()

    window.addEventListener("hashchange", scrollToHash)

    return () => {
      window.removeEventListener("hashchange", scrollToHash)
    }
  }, [filePath, fileName])

  return (
    <DiffFileHeaderStyles.Container ref={ref} id={filePath + fileName}>
      {props.vm.isCollapsible && (
        <DiffFileHeaderStyles.Collapse isCollapsed={props.vm.isCollapsed.get()} onClick={onClick}>
          <ChevronDownRegular className={Icon20} />
        </DiffFileHeaderStyles.Collapse>
      )}

      <EllipsisContainer
        onClick={onClick}
        onMouseDown={onClick && preventTextSelection}
        className={cx(HeadingStyles.Heading3, onClick ? DiffFileHeaderStyles.Clickable : undefined, props.vm.close ? DiffFileHeaderStyles.WithCloseButton : undefined)}
      >
        <Ellipsis>{fileName}</Ellipsis>
      </EllipsisContainer>

      <DiffFileHeaderStyles.FilePath>
        <Ellipsis>{filePath}</Ellipsis>
      </DiffFileHeaderStyles.FilePath>

      {props.vm.close && (
        <DiffFileHeaderStyles.CloseButton kind="icon" onClick={props.vm.close}>
          <CloseLight />
        </DiffFileHeaderStyles.CloseButton>
      )}
    </DiffFileHeaderStyles.Container>
  )
})
